export default __webpack_public_path__ + "media/images/brightnews-ai-black-5cba598cf8be6c302676bb86db99c2fb.svg";